<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">
	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="genre" class="form-label fw-bold"
				>Genre</label
			>
			<select
				id="genre"
				class="form-select"
				name="genre"
				formControlName="genre"
				aria-label="Sélectionner un genre"
				[ngClass]="{
					'is-invalid': genre.invalid,
					'is-valid': genre.dirty && genre.valid
				}"
			>
				<option [value]="GenreEnum.F">Féminin</option>
				<option [value]="GenreEnum.M">Masculin</option>
				<option [value]="GenreEnum.N">Neutre</option>
			</select>
		</div>
	</div>
	<div class="row my-4">
		<div *ngIf="form.contains('firstName')" class="col-12 col-lg">
			<label for="inputFirstName" class="form-label theme-main-color fw-bold"
				>Prénom</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputFirstName"
				name="firstName"
				formControlName="firstName"
				[ngClass]="{
					'is-invalid': firstName.invalid,
					'is-valid': firstName.dirty && firstName.valid
				}"
				(input)="checkExistBeneficiaire()"
			/>
			<div
				*ngIf="firstName.invalid && (firstName.dirty || firstName.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="firstName.errors?.required">Un prénom est requis</span>
				<span *ngIf="firstName.errors?.maxlength"
					>Le prénom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="firstName.errors?.pattern"
					>Le prénom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
		<div *ngIf="form.contains('lastName')" class="col-12 col-lg">
			<label for="inputLastName" class="form-label theme-main-color fw-bold"
				>Nom</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputLastName"
				name="lastName"
				formControlName="lastName"
				[ngClass]="{
					'is-invalid': lastName.invalid,
					'is-valid': lastName.dirty && lastName.valid
				}"
				(input)="checkExistBeneficiaire()"
			/>
			<div
				*ngIf="lastName.invalid && (lastName.dirty || lastName.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="lastName.errors?.required">Un nom est requis</span>
				<span *ngIf="lastName.errors?.maxlength"
					>Le nom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="lastName.errors?.pattern"
					>Le nom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('birthDate')" class="col-12 col-lg">
			<label for="birthDate" class="form-label theme-main-color fw-bold"
				>Date de naissance</label
			>
			<input
				autocomplete="off"
				type="text"
				bsDatepicker
				class="form-control"
				id="birthDate"
				formControlName="birthDate"
				[ngClass]="{
					'is-invalid': birthDate.invalid,
					'is-valid': birthDate.dirty && birthDate.valid
				}"
				(ngModelChange)="checkExistBeneficiaire()"
			/>
		</div>
		<div *ngIf="form.contains('address')" class="col-12 col-lg">
			<label for="inputAddresse" class="form-label theme-main-color fw-bold"
				>Adresse</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputAddresse"
				name="address"
				[typeahead]="addressList"
				[typeaheadAsync]="true"
				typeaheadOptionField="displayName"
				(typeaheadLoading)="changeTypeaheadLoading($event)"
				formControlName="address"
				(keyup)="selectedAddressKeyUp($event.target)"
				(typeaheadOnSelect)="onAddressSelect($event)"
				
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('email')"  class="col-12 col-lg-6">
			<label for="inputEmail" class="form-label theme-main-color fw-bold"
				>Email</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputEmail"
				name="email"
				formControlName="email"
			/>
		</div>
		<div *ngIf="form.contains('telephone')" class="col-12 col-lg-6">
			<label for="inputTel" class="form-label theme-main-color fw-bold"
				>Téléphone</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputTel"
				name="telephone"
				formControlName="telephone"
				[ngClass]="{
					'is-invalid': telephone.invalid,
					'is-valid': telephone.dirty && telephone.valid
				}"
			/>
			<div *ngIf="telephone.invalid" class="invalid-feedback">
				<span *ngIf="telephone.errors?.pattern"
					>Veuillez saisir un numéro de téléphone correct : 0123456789</span
				>
			</div>
		</div>
	</div>

	<!-- <div class="row my-4">
		<div class="col-12 col-lg">
			<label for="eligibiliteBeneficiaire" class="form-label fw-bold"
				>Statut bénéficiaire</label
			>
			<select
				id="eligibiliteBeneficiaire"
				class="form-select"
				name="eligibiliteBeneficiaire"
				formControlName="eligibiliteBeneficiaire"
				>
				<option *ngFor="let eligibiliteBeneficiaire of listEligibiliteBeneficiaire" value="{{ eligibiliteBeneficiaire.id }}">
					{{ eligibiliteBeneficiaire.name}}
				</option>
			</select>
		</div>
	</div> -->

	<!-- <div class="row my-4">
		<div class="col-12 col-lg">
			<label for="situationFamiliale" class="form-label fw-bold"
				>Situation familiale</label
			>
			<select
				id="situationFamiliale"
				class="form-select"
				name="situationFamiliale"
				formControlName="situationFamiliale"
				>
				<option *ngFor="let situationFamiliale of listSituationFamiliale" value="{{ situationFamiliale.id }}">
					{{ situationFamiliale.name}}
				</option>
			</select>
		</div>
	</div> -->

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="statutProfessionnel" class="form-label fw-bold"
				>Statut professionnel</label
			>
			<select
				id="statutProfessionnel"
				class="form-select"
				name="statutProfessionnel"
				formControlName="statutProfessionnel"
				>
				<option *ngFor="let statutProfessionnel of listStatutProfessionnel" value="{{ statutProfessionnel.id }}">
					{{ statutProfessionnel.name}}
				</option>
			</select>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="expertises" class="form-label fw-bold">Types de handicap</label>
			<div class="row">
				<div
					class="col-md-4 check"
					*ngFor="let expertise of listExpertise | orderBy : 'name' : 'asc'"
				>
				<div *ngIf="expertise.id !== 0">
					<input
						type="checkbox"
						name="{{ expertise.id }}"
						class="form-check-input"
						[value]="expertise"
						[checked]="isExpertiseCheck(expertise)"
						[disabled]="isExpertiseDisabled(expertise)"
						[ngClass]="{
							'theme-main-color-check': isExpertiseCheck(expertise)
						}"
						(change)="updateSelectedExpertise($event, expertise)"
					/>
					<label class="ms-2 form-check-label text-dark">
						{{ expertise.name }}
					</label>
				</div>
			</div>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="handicapPrincipal" class="form-label fw-bold"
				>Nature du handicap principal</label
			>
			<select
				id="handicapPrincipal"
				class="form-select"
				name="handicapPrincipal"
				formControlName="handicapPrincipal"
				aria-label="Sélectionner un handicap"
				[ngClass]="{
					'is-invalid': handicapPrincipal.invalid,
					'is-valid': handicapPrincipal.dirty && handicapPrincipal.valid
				}"
			>
				<option *ngFor="let handicapPrincipal of listOptionHandicapPrincipal" value="{{ handicapPrincipal }}">
					{{ handicapPrincipal}}
				</option>
			</select>
		</div>
	</div>
	<div *ngIf="this.isHVSelected" class="row my-4">
		<div class="col-12 col-lg">
			<label for="degreSurdite" class="form-label fw-bold"
				>Degré de surdité</label
			>
			<select
				id="degreSurdite"
				class="form-select"
				name="degreSurdite"
				formControlName="degreSurdite"
				aria-label="Sélectionner un handicap"
				[ngClass]="{
					'is-invalid': degreSurdite.invalid,
					'is-valid': degreSurdite.dirty && degreSurdite.valid
				}"
			>
				<option *ngFor="let degreSurdite of listOptionDegreSurdite" value="{{ degreSurdite }}">
					{{ degreSurdite}}
				</option>
			</select>
		</div>
	</div>
	<div *ngIf="this.isHVSelected" class="row my-4">
		<div class="col-12 col-lg">
			<label for="modeCommunication" class="form-label fw-bold"
				>Mode de communication</label
			>
			<select
				id="modeCommunication"
				class="form-select"
				name="modeCommunication"
				formControlName="modeCommunication"
				aria-label="Sélectionner un handicap"
				[ngClass]="{
					'is-invalid': modeCommunication.invalid,
					'is-valid': modeCommunication.dirty && modeCommunication.valid
				}"
			>
				<option *ngFor="let modeCommunication of listOptionModeCommunication" value="{{ modeCommunication }}">
					{{ modeCommunication}}
				</option>
			</select>
		</div>
	</div>

	<!-- <div class="row my-4">
		<div class="col-12 col-lg">
			<label for="typeHandicapDetail" class="form-label fw-bold"
				>Maladie chronique invalidante</label
			>
			<select
				id="typeHandicapDetail"
				class="form-select"
				name="typeHandicapDetail"
				formControlName="typeHandicapDetail"
				aria-label="Sélectionner une maladie"
				[ngClass]="{
					'is-invalid': typeHandicapDetail.invalid,
					'is-valid': typeHandicapDetail.dirty && typeHandicapDetail.valid
				}"
			>
				<option *ngFor="let typeHandicapDetail of listTypeHandicapDetail" value="{{ typeHandicapDetail.id }}">
					{{ typeHandicapDetail.name}}
				</option>
			</select>
		</div>
	</div> -->

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="tauxReconnaissance" class="form-label fw-bold"
				>Titre du bénéficiaire de l’obligation d’emploi</label
			>
			<select
				id="tauxReconnaissance"
				class="form-select"
				name="tauxReconnaissance"
				formControlName="tauxReconnaissance"
				aria-label="Sélectionner un taux de reconnaissance"
				>
				<option *ngFor="let taux of listTauxReconnaissance" value="{{ taux.id }}">
					{{ taux.name }}
				</option>
			</select>
		</div>
	</div>

	<!-- <div class="row my-4">
		<div *ngIf="form.contains('origineHandicap')" class="col-12 col-lg">
			<label for="origineHandicap" class="form-label fw-bold"
				>Origine de l'handicap</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorOrigineHandicap"> </ngx-editor-menu>
				<ngx-editor [editor]="editorOrigineHandicap" formControlName="origineHandicap"></ngx-editor>
			</div>
		</div>
	</div> -->
	<!-- <div class="row my-4">
		<div *ngIf="form.contains('doleances')" class="col-12 col-lg">
			<label for="doleances" class="form-label theme-main-color fw-bold"
				>Doléances</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorDoleances"> </ngx-editor-menu>
				<ngx-editor [editor]="editorDoleances" formControlName="doleances"></ngx-editor>
			</div>
		</div>
	</div> -->

	<!-- <div class="row my-4">
		<div *ngIf="form.contains('rapportHandicap')"  class="col-12">
			<label for="rapportHandicap" class="form-label theme-main-color fw-bold"
				>Rapport à l'handicap</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorRapportHandicap"> </ngx-editor-menu>
				<ngx-editor [editor]="editorRapportHandicap" formControlName="rapportHandicap"></ngx-editor>
			</div>
		</div>
	</div> -->

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="niveauEtude" class="form-label fw-bold"
				>Niveau de qualification professionnelle</label
			>
			<select
				id="niveauEtude"
				class="form-select"
				name="niveauEtude"
				formControlName="niveauEtude"
				aria-label="Sélectionner un niveau d'étude"
				>
				<option *ngFor="let niveauEtude of listNiveauEtude" value="{{ niveauEtude.id }}">
					{{ niveauEtude.name }}
				</option>
			</select>
		</div>
		<div class="col-12 col-lg">
			<label for="niveauQualification" class="form-label fw-bold"
				>Situation professionnelle au moment du dépôt de la demande</label
			>
			<select
				id="niveauQualification"
				class="form-select"
				name="niveauQualification"
				formControlName="niveauQualification"
				aria-label="Sélectionner un niveau de qualification"
				>
				<option *ngFor="let niveauQualification of listNiveauQualification" value="{{ niveauQualification.id }}">
					{{ niveauQualification.name }}
				</option>
			</select>
		</div>
	</div>

	<!-- <div class="row">
		<span class="theme-main-color fs-4 col">Diplômes</span>
	</div>

	<div class="row my-5">
		<div class="d-flex justify-content-start">
			<button
				*ngIf="form.get('diplomes')"
				class="btn theme-green-button"
				type="button"
				(click)="onAddDiplome()"
				>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Ajouter un diplôme
			</button>
		</div>
	</div>

	<div formArrayName="diplomes">
		<div *ngFor="let row of diplomesBeneficiaire.controls; let pointIndex = index;" [formGroupName]="pointIndex">
			<div class="row my-4">
				<div class="col-12 col-lg">
					<label for="etablissement" class="form-label theme-main-color fw-bold"
						>Etablissement</label
					>
					<input
						autocomplete="off"
						type="text"
						class="form-control"
						id="etablissement"
						name="etablissement"
						formControlName="etablissement"
					/>
				</div>
				<div class="col-12 col-lg">
					<label for="annee" class="form-label theme-main-color fw-bold"
						>Année</label
					>
					<input
						autocomplete="off"
						type="text"
						class="form-control"
						id="annee"
						name="annee"
						formControlName="annee"
					/>
				</div>
			</div>
			<div class="row my-4">
				<div class="col-12 col-lg">
					<label for="niveauEtude" class="form-label fw-bold"
						>Niveau d'étude</label
					>
					<select
						id="niveauEtude"
						class="form-select"
						name="niveauEtude"
						formControlName="niveauEtude"
						>
						<option *ngFor="let niveauEtude of listNiveauEtude" value="{{ niveauEtude.id }}">
							{{ niveauEtude.name}}
						</option>
					</select>
				</div>
				<div class="col-12 col-lg">
					<label for="amenagement" class="form-label fw-bold"
						>Aménagement</label
					>
					<select
						id="amenagement"
						class="form-select"
						name="amenagement"
						formControlName="amenagement"
						>
						<option *ngFor="let amenagement of listAmenagement" value="{{ amenagement.id }}">
							{{ amenagement.name}}
						</option>
					</select>
				</div>
			</div>
			<div class="">
				<a
					(click)="removeDiplome(pointIndex)"
					class="btn theme-red-button px-4"
				>
				Supprimer un diplôme
				</a>
			</div>
		</div>
	</div> -->

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="
					!form.valid ||
					!(isAddressDefault.value || isAddressSelected.value) ||
					isValidateButtonClicked.value
				"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>

<ng-template #listExistBeneficiaire id="listExistBeneficiaire">
	<div class="modal-header border-0 px-lg-5 px-2">
		<h4>Bénéficiaire déjà existant</h4>
	</div>

	<div class="modal-body">
		<span>
			Il existe un  bénéficiaire avec le même nom, prénom et date de naissance (Veuillez cliquer sur le bouton 
			"Mettre à jour" pour ajouter le bénéficiaire existant à votre service)
		</span>
		<div
			*ngFor="
					let beneficiaire of existBenefList
				"
				class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
			>
				<div class="col-lg-2 col">
					<span class="align-middle"
						>{{ beneficiaire.lastName }} {{	beneficiaire.firstName }}
					</span>
				</div>
				<div class="col-lg-3 col">
					<span class="align-middle"
						>Date de naissance {{ beneficiaire.birthDate | date : 'dd/MM/yyyy'}}
					</span>
				</div>
				<div class="col-lg-4 col">
					<span
						*ngFor="let exp of beneficiaire.typeHandicaps; let ilast = last"
						class="me-1"
					>
						{{ exp && ' ' + exp.name }}{{ exp && (ilast ? '' : ',') }}
					</span>
				</div>
				<div class="col-lg-3 col">
					<button
						class="btn theme-green-button"
						(click)="addBenefService(beneficiaire)"
					> Mettre à jour
					</button>
				</div>
			</div>
	</div>
	<div class="modal-footer">
		<a class="btn theme-red-button ms-3" (click)="benefListModalRef.hide()"
			>Fermer</a
		>
	</div>
</ng-template>
